let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("UpA6h")).then(() => parcelRequire('8B8Sy'));